<template>
	<v-autocomplete
		v-model="currentValue"
		:items="currentOptions"
		:item-text="(i) => `${$t(`$country.${i.name}`)} (${i.code})`"
		item-value="id"
		:label="label"
		:disabled="!ready || disabled"
		:loading="!ready && !disabled"
		outlined
		class="rounded-xl"
		:clearable="clearable"
		clear-icon="icon-cross"
		append-icon="icon-angle-down"
		:rules="rules"
		:prepend-icon="prependIcon"
		@change="changeAction"
	/>
</template>

<script>
import remote from "../../data/remote";

export default {
	props: ["value", "options", "eager", "label", "clearable", "disabled", "rules", "prepend-icon"],
	data() {
		return {
			currentValue: null,
			currentOptions: [],
			ready: false,
		};
	},
	watch: {
		currentValue(val) {
			this.$emit("input", val);
		},
		value(val) {
			this.currentValue = this.value || null;
		},
		options(val) {
			this.handleProps();
		},
	},
	methods: {
		handleProps() {
			if (this.options) {
				this.handleOptions(this.options);
				this.ready = true;
			} else if (this.eager) this.loadOptions();
		},
		handleOptions(options) {
			this.currentOptions = options;
		},
		loadOptions() {
			remote.structures.getCountries({
				onSuccess: (result) => {
					this.handleOptions(result.items);
					this.ready = true;
				},
			});
		},
		changeAction(id) {
			this.$emit(
				"change",
				this.currentOptions.find((i) => i.id === id)
			);
		},
	},
	created() {
		this.currentValue = this.value || null;
		this.handleProps();
	},
};
</script>
